module.exports = __webpack_public_path__ + "FixelDisplay-RegularItalic-070d07a55673de5a83b044bc273d2ee4.woff2";